import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'normalize.css/normalize.css';
import './common/common.scss';
import './common/nav.scss';
import AOS from "aos";
import "aos/dist/aos.css";
import store from './store/index.js';
import md5 from 'md5';
import '@/icons'; 
import MetaInfo from 'vue-meta-info';
import config from '@/config'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.prototype.$md5 = md5;
Vue.use(MetaInfo);

Vue.prototype.$baseUrl = config.baseUrl;
Vue.config.productionTip = false;
AOS.init({
  duration: 1000,
  once: false,
  offset: -50,
});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')
